import React from 'react';

/** helpers */
import { sanitizeHtml } from '../../helpers/format';

const ExternalRef = ({ field }) => {
  return field.externalReference ? (
    <span
      className="form-external-reference"
      dangerouslySetInnerHTML={{
        __html: '(' + sanitizeHtml(field.externalReference) + ')',
      }}
    ></span>
  ) : (
    ''
  );
};

export default ExternalRef;
